export var AUTH_PATHS = {
    ROOT: '/auth',
};
